var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'case-field-item': true, 'long': _vm.long}},[_c('div',{staticClass:"heading"},[_vm._v(" "+_vm._s(_vm.displayHeading)+" ")]),_c('div',{staticClass:"text-container"},[_c('div',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }